export const formData = {
  title: 'Баҳолаш кўрсаткичини қўшиш',
  data: [
    { type: 'text', label: 'Изоҳ', name: 'title', value: '', size: 24 },
    { type: 'text', label: 'Балл', name: 'rate', value: '', size: 24 },
    { type: 'select', label: 'Гуруҳ', name: 'group', value: '', size: 24 },
  ],
};

export const formDataType = {
  title: 'Баҳолаш турини қўшиш',

  data: [
    { type: 'text', label: 'Изоҳ', name: 'title', value: '', size: 24 },
    {
      type: 'text',
      label: 'Бошланғич қиймат',
      name: 'startRange',
      value: '',
      size: 24,
    },
    {
      type: 'text',
      label: 'Охирги қиймат',
      name: 'endRange',
      value: '',
      size: 24,
    },
  ],
};
export const paymentPlantForm = {
  title: 'Тўлов тарфини қўшиш',

  data: [
    {
      type: 'text',
      label: 'Тариф муддати (ой)',
      name: 'term',
      value: '',
      size: 24,
    },
    {
      type: 'text',
      label: 'Суммаси (UZS)',
      name: 'price',
      value: '',
      size: 24,
    },
  ],
};

export const paymentPlanInitial = {
  term: '',
  price: '',
};

export const initialValuesAdd = {
  title: '',
  rate: '',
  group: '',
};
export const initialValuesAddType = {
  title: '',
  startRange: '',
  endRange: '',
};
export const buttons = [
  {
    id: 1,
    title: 'Ишни баҳолаш',
    value: 'rate',
  },
  {
    id: 1,
    title: 'Баҳолаш тури',
    value: 'ratetype',
  },
  {
    id: 2,
    title: 'Дам олиш кунлари',
    value: 'weekend',
  },
  // {
  //   id: 3,
  //   title: "Телеграм гуруҳ",
  //   value: "telegram",
  // },
  {
    id: 4,
    title: 'Mac Address',
    value: 'macaddress',
  },
  {
    id: 4,
    title: 'Тўлов тарифлари',
    value: 'paymentPlan',
  },
];
export const names = {
  rate: 'Иш баҳолаш',
  ratetype: 'Баҳолаш тури',
  weekend: 'Дам олиш кунлари',
  telegram: 'Телеграм гуруҳ',
  macaddress: 'Mac Address',
  paymentPlan: 'Тўлов тарифлари',
};
